import {useEffect, useState} from 'react';

export const useScrollBoundariesDetector = (ref, isRtl) => {
  const [isReachedToStart: Boolean, setReachedToStart] = useState(true);
  const [isReachedToEnd: Boolean, setReachedToEnd] = useState(true);

  const handleScroll = () => {
    const element = ref.current;

    if (!element) return;
    const {scrollLeft, scrollWidth, clientWidth} = element;

    if(!isRtl) {
      if (scrollLeft === 0) {
        setReachedToStart(false)
      } else if (Math.abs(scrollLeft + clientWidth - scrollWidth) <= 1) {
        setReachedToEnd(false)
      } else {
        setReachedToStart(true)
        setReachedToEnd(true)
      }
    } else {
      if (scrollLeft >= 0) {
        setReachedToStart(false)
      } else if (scrollWidth - Math.abs(scrollLeft - clientWidth) <= 1) {
        setReachedToEnd(false)
      } else {
        setReachedToStart(true)
        setReachedToEnd(true)
      }
    }
  };

  useEffect(() => {
    const element = ref.current;
    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, [ref.current]);

  useEffect(() => handleScroll(), []);

  return {isReachedToStart, isReachedToEnd}
};
